<app-return-overview-filter [availableReturnStates]="(returnOverview$ | async)?.availableReturnStates"
(returnOverviewFilterChanges)="setReturnOverviewFilter($event)"></app-return-overview-filter>
@if ({
  isLoading: isLoading$ | async,
  returnOverview: returnOverview$ | async
  }; as type) {
  @if (type.returnOverview && !type.isLoading) {
    <!-- BODY -->
    <div class="cx-order-history-body">
      @if (type.returnOverview.pagination.totalResults > 0) {
        <!-- Select Form and Pagination Top -->
        <div class="cx-order-history-sort top row">
          <div class="cx-order-history-form-group form-group col-sm-12 col-md-4 col-lg-4">
            <div class="sort-label"><i class="fas fa-caret-down"></i>&nbsp;{{ 'filteredDocumentsResult.sortLabel' | cxTranslate }}</div>
            <cx-sorting
              [sortOptions]="type.returnOverview.sorts"
              [sortLabels]="getSortLabels() | async"
              (sortListEvent)="changeSortCode($event)"
              [selectedOption]="type.returnOverview.pagination.sort"></cx-sorting>
          </div>
          @if (type.returnOverview.pagination.totalPages > 1) {
            <div
              class="cx-order-history-pagination col-sm-12 col-md-4 col-lg-4">
              <cx-pagination [pagination]="type.returnOverview.pagination"
              (viewPageEvent)="pageChange($event)"></cx-pagination>
            </div>
          }
        </div>
        <!-- TABLE -->
        <table class="table cx-order-history-table">
          <thead class="cx-order-history-thead-mobile">
            <th scope="col">{{ 'returnOverview.myAccount.returnNumber' | cxTranslate }}</th>
            <th scope="col">{{ 'returnOverview.myAccount.deliveryNoteNumber' | cxTranslate }}</th>
            <th scope="col">{{ 'returnOverview.myAccount.statusDisplay' | cxTranslate }}</th>
            <th scope="col">{{ 'returnOverview.myAccount.creationDate' | cxTranslate }}</th>
            <th scope="col">{{ 'returnOverview.myAccount.positionCount' | cxTranslate }}</th>
          </thead>
          <tbody>
            @for (returnItem of type.returnOverview.returns; track returnItem) {
              <tr>
                <td attr.data-label="{{ 'returnOverview.myAccount.returnNumber' | cxTranslate }}"
                  class="cx-order-history-return-number">
              <a [routerLink]="{
                  cxRoute: 'returnsDetails',
                  params: returnItem
                } | cxUrl">{{ returnItem?.returnNumber }}</a>
                </td>
                <td attr.data-label="{{ 'returnOverview.myAccount.deliveryNoteNumber' | cxTranslate }}"
                  class="cx-order-history-type-note-number">
                  {{ returnItem?.deliveryNoteNumber }}
                </td>
                <td attr.data-label="{{ 'returnOverview.myAccount.statusDisplay' | cxTranslate }}"
                  class="cx-order-history-type-status-display">
                  {{ returnItem?.statusDisplay }}
                </td>
                <td attr.data-label="{{ 'returnOverview.myAccount.creationDate' | cxTranslate }}"
                  class="cx-order-history-type-date">
                  {{ returnItem?.creationDate | date: 'dd.MM.yyyy' }}
                </td>
                <td attr.data-label="{{ 'returnOverview.myAccount.positionCount' | cxTranslate }}"
                  class="cx-order-history-type-position">
                  {{ returnItem?.positionCount }}
                </td>
              </tr>
            }
          </tbody>
        </table>
        <!-- Select Form and Pagination Bottom -->
        <div class="cx-order-history-sort bottom row">
          @if (type.returnOverview.pagination.totalPages > 1) {
            <div
              class="cx-order-history-pagination">
              <cx-pagination [pagination]="type.returnOverview.pagination"
              (viewPageEvent)="pageChange($event)"></cx-pagination>
            </div>
          }
        </div>
      } @else {
        <app-no-display-result-notice noticeHeadline="{{ 'filteredDocumentsResult.noResult' | cxTranslate }}"></app-no-display-result-notice>
      }
      <!-- NO RESULT CONTAINER -->
    </div>
  } @else {
    @if (type.isLoading) {
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  }
}
